import React from 'react';

function ImageIcon(props) {
    const { img, title, onClick, iconClass, mainClass = "img-icon" } = props;
    return (
        <div title={title} className={mainClass} onClick={onClick || null}>
            {img ?
                <img
                    className={iconClass}
                    src={img}
                    height={16}
                    width={16}
                    alt={title}
                />
                : <i className={`${iconClass}`} onClick={onClick}></i>
            }
        </div>
    )
}

export default ImageIcon